import React from 'react';

import Image from '../../Commons/Image/Image';
import List from '../../Commons/List/List';
import OLIVOS from '../../../assets/swiss-medical-center/centro_olivos.jpg';

import styles from './SwissMedicalOlivos.module.scss';

const SwissMedicalOlivos = () => {
  const leftItems = [
    { text: 'Adolescencia' },
    { text: 'Alergia e Inmunología' },
    { text: 'Cardiología' },
    { text: 'Cardiología Pediátrica' },
    { text: 'Cirugía Cardiovascular' },
    { text: 'Cirugía General' },
    { text: 'Cirugía General Pediátrica' },
    { text: 'Cirugía Plástica Reparadora' },
    { text: 'Cirugía Plástica Reparadora Pediátrica' },
    { text: 'Cirugía Torácica' },
    { text: 'Cirugía Vascular Periférica' },
    { text: 'Cirugía Videolaparoscópica' },
    { text: 'Cirugía Cabeza y Cuello' },
    { text: 'Clínica Médica' },
    { text: 'Dermatología' },
    { text: 'Dermatología Pediátrica' },
    { text: 'Diabetología' },
    { text: 'Dietistas' },
    { text: 'Electrofisiología' },
    { text: 'Endocrinología' },
    { text: 'Flebología' },
    { text: 'Gastroenterología' },
    { text: 'Ginecología' },
  ];

  const rightItems = [
    { text: 'Hematología' },
    { text: 'Hepatología' },
    { text: 'Infectología' },
    { text: 'Medicina del Deporte' },
    { text: 'Nefrología' },
    { text: 'Neumonología' },
    { text: 'Neumonología Pediátrica' },
    { text: 'Neurocirugía' },
    { text: 'Neurología' },
    { text: 'Obstetricia' },
    { text: 'Oftalmología' },
    { text: 'Ortopedia y Traumatología' },
    { text: 'Ortopedia y Traumatología Pediátrica' },
    { text: 'Otorrinolaringología' },
    { text: 'Otorrinolaringología Pediátrica' },
    { text: 'Patología Mamaria' },
    { text: 'Pediatría' },
    { text: 'Proctología' },
    { text: 'Reumatología' },
    { text: 'Urología' },
    { text: 'Urología Pediátrica' },
  ];

  return (
    <div className={styles.swiss_medical_olivos}>
      <h3>Olivos</h3>
      <p>
        <strong className={styles.swiss_medical_olivos__redText}>Dirección:</strong> Maipú 1641,
        Olivos
      </p>
      <p>
        <strong className={styles.swiss_medical_olivos__redText}>Turnos:</strong> 0810-333-8876
      </p>
      <Image
        src={OLIVOS}
        alt='Sede Olivos'
        title='Olivos'
        classes={styles.swiss_medical_olivos__image}
      />
      <p>
        <strong className={styles.swiss_medical_olivos__redText}>Atención Programada</strong>
      </p>
      <div className={styles.swiss_medical_olivos__doubleListContainer}>
        <List items={leftItems} />
        <List items={rightItems} />
      </div>
    </div>
  );
};

export default SwissMedicalOlivos;
